import { AnyAction } from 'redux';
import { BreadcrumbsState } from '../types/ConfigState';

const initialState: BreadcrumbsState = {
  routes: [],
};

export const SET_BREADCRUMB_ROUTES = 'SET_BREADCRUMB_ROUTES';

export default function breadcrumbReducer(
  state = initialState,
  action: AnyAction
): BreadcrumbsState {
  switch (action.type) {
    case SET_BREADCRUMB_ROUTES:
      return {
        ...state,
        routes: action.payload,
      };
    default:
      return state;
  }
} 